import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-sommerfest-teaser',
  imports: [
    RouterLink,
    MatListModule,
    // MatButtonModule,
    // MatIconModule
  ],
  templateUrl: './sommerfest-teaser.component.html',
  styleUrl: './sommerfest-teaser.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SommerfestTeaserComponent {

}
